import React  from "react";
import {
    Modal,
    Button, 
} from "react-bootstrap";
import { useHistory } from "react-router-dom";

export default function RefreshToken (props) {
    let history = useHistory();
    let show = props.show;
    let setShow = props.setShow;

    const logout = () => {
        history.push({pathname: '/login'});
    }

    const handleClose = () => {
        setShow(false);
    }

    // const refreshToken = () => {
    //     setShow(false);
    // }

    return (
      <>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>You've been logged in a long time.</Modal.Title>
          </Modal.Header>
            <Modal.Body>Do you want to continue the session?</Modal.Body>
          <Modal.Footer>
            {/* <Button variant="primary" onClick={refreshToken}>
              Continue
            </Button> */}
            <Button variant="danger" onClick={logout}>
              Logout
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
